import { toolActivityStateFor } from "@repo/agents/tool-activity";

import { out } from "../output/out";
import type { TranscriptEvent } from "@/lib/event/transcript-event";

/** Some tools report failure as prose on a completed call: the state knows. */
export function formatToolPart(
  part: Extract<TranscriptEvent["part"], { kind: "tool" }>,
): string {
  const { hasFailed } = toolActivityStateFor(part.toolName, {
    status: part.status,
    output: part.output,
  });
  const status = hasFailed ? "failed" : part.status;
  return `${out.paint("tool", "dim")}   ${out.cell(part.toolName)} ${out.paint(`(${status})`, "dim")}`;
}
